export enum LessonId {
    smores = 'smores',
    neonsigns = 'neonsigns',
    colorsplash = 'colorsplash',
    goache = 'goache',
    henna = 'henna',
    scratchboard = 'scratchboard',
    pastelPortrait = 'pastelPortrait',
    vinyl = 'vinyl',
    poptarts = 'poptarts',
    howtomakeagif = 'howtomakeagif',
    whatisapencilmadeof= 'whatisapencilmadeof',
}